var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_12577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7844 13.705V6.089C13.4739 7.36123 15.5569 8.59023 18.0204 9.91525C15.9885 11.0481 13.4739 12.3191 10.7844 13.705ZM25.7729 2.3012C25.3089 1.68674 24.5182 1.20843 23.6764 1.05008C21.2021 0.577728 5.76583 0.576385 3.29286 1.05008C2.6178 1.1773 2.01668 1.48481 1.5003 1.96257C-0.675489 3.99272 0.00629934 14.8798 0.530749 16.6433C0.751285 17.4066 1.03638 17.9572 1.39543 18.3185C1.85802 18.7963 2.49138 19.1253 3.21888 19.2728C5.25616 19.6964 15.7519 19.9333 23.6334 19.3364C24.3595 19.2092 25.0023 18.8696 25.5093 18.3715C27.521 16.3495 27.3839 4.85107 25.7729 2.3012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_12577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 19,
    fill: "white",
    transform: "translate(0 0.695312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1173d02e5693e61dd1e0cc78619645a4.svg";
export { ForwardRef as ReactComponent };